module.exports = __webpack_public_path__ + "img/about_txt.e738e75f.jpg";